export default __webpack_public_path__ + "static/ASPNET-1dfa0b1000d87f9e1ed591db85576291.svg";